import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default action('toggleAgenda')(select({
    store: function () { return store; },
})(function toggleAgenda(state) {
    state.store.isAgendaOpen = !state.store.isAgendaOpen;
}));
//# sourceMappingURL=toggleAgenda.js.map